import React from 'react';
import { IconProps } from './IconTypes';

const SentinelLogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M50,6 L88,18 L88,52 C88,72 72,88 50,96 C28,88 12,72 12,52 L12,18 Z M50,18 L24,26 L24,52 C24,66 34,78 50,84 C66,78 76,66 76,52 L76,26 Z" />
      <path d="M50,38 C62,38 72,46 76,52 C72,58 62,66 50,66 C38,66 28,58 24,52 C28,46 38,38 50,38 Z M50,46 C46.7,46 44,48.7 44,52 C44,55.3 46.7,58 50,58 C53.3,58 56,55.3 56,52 C56,48.7 53.3,46 50,46 Z" />
    </svg>
  );
};

export default SentinelLogo;
